<template>
    <div>

        <Row>
            <DatePicker v-model="filterDate" type="daterange" :options="dateOptions" placeholder="Select date" :clearable="false"
                        format="dd/MM/yyyy" class="filterInput" style="width: 260px" @on-change="onChangeDate"></DatePicker>
            <Button style="float: right; margin:-5px 0 6px 0" @click="onAddTruckOrder" v-if="isAdmin">Start Order</Button>
        </Row>

        <Button v-if="isAdmin" style="float: right; margin:18px 0 0 0" @click="exportTruckOrders">Export CSV</Button>
        <Tabs v-model="screen" type="card" style="margin-top: 50px">
            <TabPane :label="'Outgoing Trucks ('+outgoing_truckOrders.length+')'" name="outgoing"></TabPane>
            <TabPane :label="'Incoming Trucks ('+oncoming_truckOrders.length+')'" name="oncoming"></TabPane>
            <TabPane :label="'Open Trucks ('+open_truckOrders.length+')'" name="open"></TabPane>
        </Tabs>


        <Spin fix size="small" v-if="skipTruckOrders"></Spin>

        <div v-show="screen === 'outgoing'">
            <hot-table :settings="outgoing_hotSettings" ref="outgoing_hotTableComponent" style="margin: 20px 0 0 0">
                <hot-column v-for="(colset, index) in isAdmin?[...columns, outgoingActionObj]:[...columns]" :settings="colset" :key="index">
                    <component hot-editor v-bind:is="colset.component"
                               v-bind="{[excludeComponents.includes(colset.component)?'':'hot-renderer']: true}"></component>
                </hot-column>
            </hot-table>
        </div>
        <div v-show="screen === 'oncoming'">
            <hot-table :settings="oncoming_hotSettings" ref="oncoming_hotTableComponent" style="margin: 20px 0 0 0">
                <hot-column v-for="(colset, index) in isAdmin?[...columns, oncomingActionObj]:[...columns]" :settings="colset" :key="index">
                    <component hot-editor v-bind:is="colset.component"
                               v-bind="{[excludeComponents.includes(colset.component)?'':'hot-renderer']: true}"></component>
                </hot-column>
            </hot-table>
        </div>
        <div v-show="screen === 'open'">
            <hot-table :settings="open_hotSettings" ref="open_hotTableComponent" style="margin: 20px 0 0 0">
                <hot-column v-for="(colset, index) in [...columns]" :settings="colset" :key="index">
                    <component hot-editor  v-bind:is="colset.component"
                               v-bind="{[excludeComponents.includes(colset.component)?'':'hot-renderer']: true}"></component>
                </hot-column>
            </hot-table>
        </div>

        <Modal v-model="confirmDialog" title="Confirmation" draggable>
            <p>Are You sure want to update field {{confirmObj.col?columns[confirmObj.col].title:''}}?</p>
            <p>From <i>{{confirmObj.oldValue?confirmObj.oldValue:'-'}}</i></p>
            <p>To <i>{{confirmObj.newValue}}</i></p>
            <div slot="footer">
                <Button type="primary" style="font-weight: bolder" :loading="updateRecord_loader"
                        @click="updateRecord(confirmObj.row, confirmObj.prop, confirmObj.newValue)">
                    <span v-if="!updateRecord_loader">OK</span>
                    <span v-else>Loading...</span>
                </Button>
                <Button style="background: #999999; color: white;font-weight: bolder" @click="revertChange(confirmObj.row, confirmObj.prop, confirmObj.oldValue)">
                    CANCEL</Button>
            </div>
        </Modal>

        <add-truck-order ref="truck-order-form"></add-truck-order>

    </div>
</template>

<script>
  import {
    calculateTotalWeightOfOrders,
    CellSettings,
    CellSettings_CityManager,
    hotSettingsTruckOrders,
    truckOrderObj
  } from './Settings'
    import {dateOptions} from "../ExcelFormattedOrders/Settings"
    import { HotTable, HotColumn } from '@handsontable/vue'
    import {weightRenderer, truckOrderNumRenderer, truckOrderStatusRenderer, ewayBillRenderer} from "./RendererFunctions"
    import ActionPopup from './ActionPopup'
    import TruckPopup from "./TruckPopup"
    import {SUBSCRIBE_EXCEL_OUTGOING_TRUCK_ORDERS, SUBSCRIBE_EXCEL_ONCOMING_TRUCK_ORDERS,
            SUBSCRIBE_EXCEL_OPEN_TRUCK_ORDERS} from "../../graphql/subscription/truckOrders"
    import {generate_UPDATE_ORDER_DATA} from '../../graphql/mutations/orders'
    import moment from 'moment'
    import AddTruckOrder from "../VehicleManagement/AddTruckOrder"
    import DriverPopup from "./DriverPopup";
    import CityPopup from "./CityPopup";
  import {actionRenderer} from "../ExcelContractors/RendererFunctions";
  import {Constants} from "../../Constants/Constant";

    export default {
        name: "ExcelTruckOrders",
        components: {CityPopup, DriverPopup, AddTruckOrder, HotTable, HotColumn, ActionPopup, TruckPopup },
        props:['globalSearch'],
        apollo: {
            $subscribe: {
                outgoing_truckOrders: {
                    query: SUBSCRIBE_EXCEL_OUTGOING_TRUCK_ORDERS,
                    skip(){return this.skipTruckOrders},
                    variables () {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate
                        }
                    },
                    result ({ data }) {
                        console.log('Excel Outgoing Truck Orders Subscribed')
                        this.outgoing_truckOrders = data.outgoing_truckOrders
                        this.prepareSheetData(data.outgoing_truckOrders, 'outgoing')
                    },
                },
                oncoming_truckOrders: {
                    query: SUBSCRIBE_EXCEL_ONCOMING_TRUCK_ORDERS,
                    skip(){return this.skipTruckOrders},
                    variables () {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate
                        }
                    },
                    result ({ data }) {
                        console.log('Excel Oncoming Truck Orders Subscribed')
                        this.oncoming_truckOrders = data.oncoming_truckOrders
                        this.prepareSheetData(data.oncoming_truckOrders, 'oncoming')
                    },
                },
                open_truckOrders: {
                    query: SUBSCRIBE_EXCEL_OPEN_TRUCK_ORDERS,
                    skip(){return this.skipTruckOrders},
                    variables () {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate
                        }
                    },
                    result ({ data }) {
                        console.log('Excel Open Truck Orders Subscribed')
                        this.open_truckOrders = data.open_truckOrders
                        this.prepareSheetData(data.open_truckOrders, 'open')
                    },
                },
            },
        },
        data: function () {
            return{
                screen: 'outgoing',
                screenArr: ['outgoing', 'oncoming', 'open'],
                truckOrders: [],
                excludeComponents: ['ActionPopup'],
                outgoing_truckOrders: [],
                oncoming_truckOrders: [],
                open_truckOrders: [],
                skipTruckOrders: true,
                filterDate: [moment().subtract(2, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                startDate: moment().subtract(2, 'days').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                dateOptions: dateOptions,
                columns: [
                    //table_key_intermediate
                    {
                        title: 'Booking<br> Date',
                        data: 'bookingDate',
                        type: 'date',
                        dateFormat: 'DD/MM/YYYY'
                    },
                    {
                        title: 'Truck Order<br> Number',
                        data: 'truckOrderNumber',
                        renderer: truckOrderNumRenderer
                    },
                    {
                        title:'Status',
                        data: 'internalStatusId',
                        component: 'ActionPopup',
                        renderer: truckOrderStatusRenderer
                    },
                    {
                        title:'Truck<br> Number',
                        data: 'truckPlateNum',
                        component: 'TruckPopup'
                    },
                    {
                        title:'Transporter',
                        data: 'transporter'
                    },
                    {
                        title:'Driver',
                        data: 'driver',
                        component: 'DriverPopup'
                    },
                    {
                        title:'Eway Bill No.',
                        data: 'truckOrders_ewayBillNo',
                        renderer: (...args) => ewayBillRenderer(...args, true)
                    },
                    {
                        title:'No of<br> Orders',
                        data: 'numOfOrders',
                        type: 'numeric'
                    },
                    {
                        title:'Total/<br>Committed<br>Wt(Kg)',
                        data: 'truckOrders_commitedWeight',
                        type: 'numeric',
                        renderer: (...args) => weightRenderer(...args, true)
                    },
                    {
                        title:'Pickup<br> City',
                        data: 'fromCity',
                        component: 'CityPopup'
                    },
                    {
                        title:'Drop<br> City',
                        data: 'toCity',
                        component: 'CityPopup'
                    },
                    {
                        title:'Rate<br> (per ton)',
                        data: 'truckOrders_price',
                        type: 'numeric',
                    },
                    {
                        title:'LR<br> Comm',
                        data: 'lrCommision',
                        type: 'numeric'
                    },
                    {
                        title:'Approx<br> Payment',
                        data: 'payment',
                        type: 'numeric',
                        numericFormat: { pattern: '0,00' }
                    },
                    // {
                    //     title:'Truck<br>Order<br>Status',
                    //     data: 'truckOrders_status',
                    //     type: 'dropdown',
                    //     source: ['InProgress', 'open', 'Cancel']
                    //
                    // },
                ],
                outgoingActionObj:{title:'Action', data: 'action', renderer: (...args) => actionRenderer(...args, this, 'outgoing_truckOrders', 'onEditTruckOrder', 'onDeleteTruckOrder')},
                oncomingActionObj:{title:'Action', data: 'action', renderer: (...args) => actionRenderer(...args, this, 'oncoming_truckOrders', 'onEditTruckOrder', 'onDeleteTruckOrder')},
                hotSettings: hotSettingsTruckOrders([110, 170, 145, 100, 145, 140, 120, 80, 110, 80, 70, 80, 80, 90, 100, 60], this),
                outgoing_hotSettings: hotSettingsTruckOrders([110, 170, 145, 100, 145, 140, 130, 100, 120, 100, 90, 100, 90, 110, 100, 60],
                                                             this, 'outgoing_hotTableComponent'),
                oncoming_hotSettings: hotSettingsTruckOrders([110, 170, 145, 100, 145, 140, 130, 100, 120, 100, 90, 100, 90, 110, 100, 60],
                                                             this, 'oncoming_hotTableComponent'),
                open_hotSettings: hotSettingsTruckOrders([110, 170, 145, 100, 145, 140, 130, 100, 120, 100, 90, 100, 90, 110, 100],
                                                              this, 'open_hotTableComponent'),
                confirmDialog: false,
                confirmObj: {},
                runCommentMethod: false,
                updateRecord_loader: false,
                evaluatedWeight: 0,
                addTruckOrderDrawer: false
            }
        },
        computed: {
          isAdmin: function(){
            return this.$store.state.userObj.role[0].id === Constants.adminRoleId
          }
        },
        methods:{
            onChangeDate(evt){
                this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
            },
            prepareSheetData(data, screen){
                let mainArr = [], totalOrders = 0, totalWeight = 0;
                data.forEach(curnt => {
                    curnt.obj = {
                        bookingDate: moment(curnt.bookingDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                        truckOrderNumber: curnt.truckOrderNumber,
                        internalStatusId: curnt.InternalStatus?curnt.InternalStatus.id:'',
                        truckPlateNum: curnt.truck.platNo,
                        transporter: curnt.Transporter.name,
                        driver: curnt.driverDetail.name,
                        truckOrders_ewayBillNo: curnt.ewayBillNo,
                        numOfOrders: curnt.orderDetailsArr.length,
                        truckOrders_commitedWeight: parseInt(curnt.commitedWeight),
                        fromCity: curnt.fromCity,
                        toCity: curnt.toCity,
                        truckOrders_price: curnt.price || 0,
                        lrCommision: curnt.lrCommision,
                        payment: (curnt.commitedWeight*curnt.price/1000)-curnt.lrCommision,
                        truckOrders_status: curnt.status,
                        orderDetailsArr: curnt.orderDetailsArr,
                        truckOrderId: curnt.id,
                        internalstatus: curnt.InternalStatus?curnt.InternalStatus.name:'',
                        action: ''
                    }
                    mainArr.push(curnt.obj)
                    totalOrders = totalOrders + curnt.orderDetailsArr.length;
                    totalWeight = totalWeight + Number(calculateTotalWeightOfOrders(curnt.orderDetailsArr));
                })
                if(mainArr.length) mainArr.push({...truckOrderObj, numOfOrders: totalOrders, truckOrders_commitedWeight: totalWeight+'NA'}); //appending NA to skip renderer
                let hotSettingsVariable = screen + '_hotSettings'
                this[hotSettingsVariable].data = mainArr
                this.updateTableSettings(screen, mainArr.length)
            },
            updateTableSettings(screen, numOfRows){
                if(screen === 'open') return;

                let hotTableComponentVariable = screen + '_hotTableComponent'
                if(!this.$refs[hotTableComponentVariable]) return
                let hotInstance = this.$refs[hotTableComponentVariable].hotInstance

                // let colIndexToHide = hotInstance.propToCol('action');
                // this[screen + '_hotSettings'].hiddenColumns = {columns: [colIndexToHide]};

                let settings = this.isAdmin ? CellSettings : CellSettings_CityManager;       //settings based on User Role
                hotInstance.updateSettings({
                    cells: function (row, col, prop) {
                        var cellProperties = {};
                        let stageId = hotInstance.getDataAtRowProp(row, 'internalStatusId')
                        if(stageId && settings[stageId] && settings[stageId][prop]){
                                cellProperties.readOnly = settings[stageId][prop].isReadOnly
                        }
                        if(row === numOfRows-1) cellProperties.className = 'spotlight';
                      return cellProperties;
                    }
                })
            },
            async updateRecord(row, prop, newValue){
                this.updateRecord_loader = true
                let truckOrdersVariable = this.screen + '_truckOrders'
                let hotInstance = this.$refs[this.screen + '_hotTableComponent'].hotInstance
                let pRow = hotInstance.toPhysicalRow(row)                        //When accessing original array

                let obj = {}, id = '', record = this[truckOrdersVariable][pRow];

                let [table, key, intermediate] = prop.split('_')                                               //eg. orderDetails_lrName_lrObject

                if(!intermediate){
                    obj[key] = newValue
                }

                switch(key){
                    case 'price':
                    case 'commitedWeight': obj[key] = newValue.toString()
                        break
                }

                switch(table){
                    case 'truckOrders': id = record.id
                        break
                }
                let response = await this.$apollo.mutate({
                    mutation: generate_UPDATE_ORDER_DATA(table),
                    variables: {id: id, obj: obj},
                })
                if (response.data) {
                    this.updateRecord_loader = false
                    this.$Message.success('Field ' +key+ ' updated successfully!')
                    this.confirmDialog = false
                    // this.$apollo.queries.truckOrders.refetch()
                }
            },
            revertChange(row, prop, oldValue){
                let hotTableComponentVariable = this.screen + '_hotTableComponent'
                this.$refs[hotTableComponentVariable].hotInstance.setDataAtRowProp(row, prop, oldValue, 'revert')
                this.confirmObj = {}
                this.confirmDialog = false
            },
            onAddTruckOrder(){
              this.$refs['truck-order-form'].editMode = false;
              this.addTruckOrderDrawer = true;
            },
            onEditTruckOrder(row){
              row = {...row, truckId: row.truck.id, driverId: row.driverDetail.id, transporterId: row.Transporter.id}
              this.$refs['truck-order-form'].editMode = true;
              this.$refs['truck-order-form'].setTruckOrderForm(row);
              this.addTruckOrderDrawer = true;
            },
            onDeleteTruckOrder(truckOrderId, index){
              if(this[this.screen+ '_truckOrders'][index].orderDetailsArr.length){
                this.$Message.error('Truck Order can\'t be deleted as it contains order/s!');
                return
              }
              this.$refs['truck-order-form'].onDeleteTruckOrder(truckOrderId);
            },
            exportTruckOrders(){
              let hotInstance = this.$refs[this.screen + '_hotTableComponent'].hotInstance;
              let endRow = hotInstance.countRows();
              let endColumn = hotInstance.propToCol('action') - 1;
              let exportPlugin = hotInstance.getPlugin('exportFile');
              exportPlugin.downloadFile('csv', {
                columnHeaders: true,
                range:[0, 0, endRow, endColumn],
                filename: 'TruckOrders_'+this.screen+'_'+ moment().format('DD_MMM_YYYY_HH_mm'),
              });
            }
        },
        mounted(){
            setTimeout(() => {
                this.skipTruckOrders = false
            }, 500)

        }
    }
</script>

<style scoped>
    /deep/  .ivu-spin-fix {
        top: 43px;
        left: 16px;
        z-index: 8;
        width: 86vw;
        height: 40vh;
    }
    /deep/ .handsontable > .ht_master{
        font-size: 14px;
    }
    /deep/ .handsontable > .ht_master > .wtHolder{
        /*width: 100% !important;*/
        width: unset !important;
        height: unset !important;
    }
    /deep/ .handsontable span.colHeader {
        font-size: 13px;
    }
    /deep/.handsontable td{
        vertical-align: middle !important;
        padding: 0 1px 0 1px !important;
        white-space: unset !important;
        font-size: 13px;
    }

    /deep/.handsontable th{
        background-color: #d9d9d9;
        color: #222;
        text-align: center;
        font-weight: 600;
        vertical-align: middle !important;
        white-space: nowrap !important;
        padding: 0 0px 0 0px !important;
    }

    /deep/ .handsontable .spotlight{
      font-size: 15px;
      text-align: center;
      color: teal;
      font-weight: 600;
    }

    .filterInput{
        width: 80%;
    }
    /deep/ .ivu-date-picker-cells  {
        font-size: 12px !important;
    }
    /deep/ .ivu-picker-panel-sidebar  {
        width:125px !important;
        margin-left:-116px !important;
    }
</style>
<style>
    .truck-order-num-txt:hover {
        text-decoration: underline;
    }
    .filterInput{
        width: 80%;
    }
    .refresh-icon{
        float: right;
        margin: 9px 16px;
        font-size: 14px;
        cursor: pointer;
    }
    .action-edit{
      font-size: 12px;
      color:grey;
      margin-right:15px;
      cursor: pointer;
    }
    .action-delete{
      font-size: 12px;
      color:red;
      cursor: pointer;
    }
    .action-delete:hover{
      color: #FF8C00;
    }
    .action-edit:hover{
      color: #c0c0c0;
    }
</style>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>
